/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class extends Logic
{
  constructor (zone, parent)
  {
    super(zone);

    this.parent = parent;
  }


  getNeighbor (index)
  {
    const displayHex = this.object.getDisplayHex().getNeighborsInOrder()[index];

    return this.parent.getZone(displayHex);
  }


  getNeighbors ()
  {
    return this.object.getDisplayHex().getNeighborsInOrder().map(displayHex => this.parent.getZone(displayHex));
  }


  isExternalBorder (neighbor)
  {
    return this.object.isExternalBorder(neighbor !== null ? neighbor.object : null);
  }


  isTemporaryBorder (neighbor)
  {
    return this.object.isTemporaryBorder(neighbor !== null ? neighbor.object : null);
  }


  isGroupBorder (neighbor)
  {
    return this.object.isGroupBorder(neighbor !== null ? neighbor.object : null);
  }


  isJaggedBorder (neighbor)
  {
    return this.object.isJaggedBorder(neighbor !== null ? neighbor.object : null);
  }



  isEmphasized ()
  {
    return this.parent.emphasis.matches(this.getEntity());
  }


  isDimmed ()
  {
    return this.parent.dimming.matches(this.getEntity());
  }


  getBeaconValue ()
  {
    return this.object.getBeaconValue();
  }


  isEstablished ()
  {
    return this.object.isEstablished();
  }


  getBackgroundBand (now)
  {
    return this.object.getBackgroundBand(now);
  }


  getDisplayHex ()
  {
    return this.object.getDisplayHex();
  }


  getEntityHex ()
  {
    return this.object.getEntityHex();
  }


  getColor ()
  {
    return this.object.getColor();
  }


  equals (other)
  {
    return super.equals(other) && this.parent.equals(other.parent);
  }


};
